import React, { PropsWithChildren } from 'react'
import { useParams } from 'react-router-dom'
import { HttpStatus } from '@notino/react-toolkit/renderer/fragment/contexts/HttpContext'

// types
import { ContextProps } from '../types/types'

// utils
import { getValidSalonsCategoryPageQuery } from '../utils/helper'
import { salonsCategoryPageSchema } from '../utils/zodQuerySchemas'

// components
import SalonsCategoryPage from '../pages/SalonsCategoryPage/SalonsCategoryPage'

// hooks
import useZodQueryParams from '../hooks/useZodQueryParams'

type SalonsCategoryRouteParams = {
	categorySlug: string
	citySlug?: string
}

type SalonsCategoryRouteProps = PropsWithChildren<ContextProps & {}>

const SalonsCategoryRoute: React.FC<SalonsCategoryRouteProps> = (props) => {
	const { categorySlug, citySlug } = useParams<SalonsCategoryRouteParams>()

	const [query, setQuery] = useZodQueryParams(salonsCategoryPageSchema)

	if (!categorySlug) {
		return <HttpStatus status={404}>{null}</HttpStatus>
	}

	/**
	 * Additional validation for query params not handled by zod
	 * e.g. dateFrom should be less than dateTo
	 */
	const validQuery = getValidSalonsCategoryPageQuery(query)

	return <SalonsCategoryPage {...props} categorySlug={categorySlug} query={validQuery} setQuery={setQuery} citySlug={citySlug} />
}

export default SalonsCategoryRoute
